import * as React from 'react';
import { connect } from 'react-redux';
import { withAuth, AuthContextProps, hasAuthParams } from "react-oidc-context";
import { ApplicationState } from '../../store';
import { Loader } from '../components/Loader';
import * as UserStore from '../../store/UserStore';


const dispatchAction = {
    LoadUserAction: UserStore.actionCreators.LoadUserAction,
    UnLoadUserAction: UserStore.actionCreators.UnLoadUserAction
}

type AuthWrapperProps = {
    auth: AuthContextProps,
    userState: UserStore.UserState,
} &
    typeof dispatchAction


interface AuthWrapperState {
    isOperation: boolean;
    isAuthenticated: boolean;

}

class AuthWait extends React.PureComponent {
    componentDidMount(): void {
    }
    public render() {
        return (
            <React.Fragment>
                <Loader />
            </React.Fragment>
        )
    }
}


class AuthWrapper extends React.PureComponent<AuthWrapperProps, AuthWrapperState> {
    constructor(props: AuthWrapperProps) {
        super(props)
        this.state = {
            isOperation: false,
            isAuthenticated: false
        }
        this.props.auth?.events.addSilentRenewError(() => {

            this.props.UnLoadUserAction();
            this.setState({
                isOperation: false,
                isAuthenticated: false

            })


        })
        this.props.auth?.events.addAccessTokenExpired(() => {

            this.props.UnLoadUserAction();
            this.setState({
                isAuthenticated: false

            })
            //this.props.auth?.signinRedirect();


        })

        this.props.auth?.events.addAccessTokenExpiring(async () => {
            if (this.state.isAuthenticated) {
                this.props.auth.signinSilent()
            }


        })



        /* this.props.auth?.events.addUserSignedIn(() => {
             this.setState({
                 isAvaibleSignin: false,
                 cntSignin:0
             })
 
         })*/




    }




    async componentDidUpdate(prevProps: AuthWrapperProps, prevState: AuthWrapperState) {


        if (!this.props.auth?.isLoading &&
            this.props.auth.isAuthenticated &&
            prevProps.auth?.isLoading
        ) {
            if (this.props.auth.user != null) {
                await this.props.LoadUserAction(this.props.auth.user)
            }
            if (!this.state.isAuthenticated) {
                this.setState({
                    isAuthenticated: true

                })


            }

        }




        if (!this.props.auth.activeNavigator &&
            !this.props.auth.isAuthenticated &&
            !this.props.auth.isLoading &&
            !this.state.isAuthenticated &&
            !this.state.isOperation
        ) {

            this.props.auth.signinRedirect()
        }






    }

    public render() {
        if (this.props.userState.isUserLoad) {
            return (
                <React.Fragment>
                    {this.props.children}
                </React.Fragment>
            )
        }
        else {
            return (

                <React.Fragment>
                    <AuthWait />
                </React.Fragment>
            )
        }



    }
}



export default connect(
    (state: ApplicationState) => ({ userState: state.user }),
    dispatchAction
)(withAuth(AuthWrapper) as any);

